import React from 'react';
import { useTranslation } from 'react-i18next';

export default function SessionDate({ date }) {
    const { t } = useTranslation();

    return <span>{t('attendees.invitations.summary.date', { date })}</span>;
}
